// extracted by mini-css-extract-plugin
export var select = "_pt-0";